import {PAYMENT_PROVIDER_OPN} from '../../constants/payments'
import {IntegrationsStatus, ProviderHealthState} from './types'

const STATES: ProviderHealthState[] = ['UP', 'DEGRADED', 'DOWN']

const isRecord = (value: unknown): value is Record<string, unknown> => typeof value === 'object' && value !== null

// Anything but a body with a `providers` object (HTML error page, empty 204, null) is "unknown".
export const parseIntegrationsStatus = (data: unknown): IntegrationsStatus | null => {
  if (!isRecord(data) || !isRecord(data.providers)) {
    return null
  }
  return data as IntegrationsStatus
}

// The gate keys off the charge op only: the provider-level state can read DOWN while charges work.
export const getOpnChargeState = (status: IntegrationsStatus | null | undefined): ProviderHealthState | null => {
  const opn: unknown = status?.providers.opn
  if (!isRecord(opn) || !isRecord(opn.ops) || !isRecord(opn.ops.charge)) {
    return null
  }
  const state = opn.ops.charge.state
  return STATES.find((value) => value === state) || null
}

export type ChargeGateArgs = {
  provider?: string | null
  chargeState: ProviderHealthState | null | undefined
  totalPrice?: number | null
}

// Only an Opn venue, only a paid checkout, only a charge op that reads DOWN. Unknown = no gate.
export const isOpnChargeGated = ({provider, chargeState, totalPrice}: ChargeGateArgs): boolean =>
  provider === PAYMENT_PROVIDER_OPN && chargeState === 'DOWN' && totalPrice !== 0

export const isOpnChargeDegraded = ({provider, chargeState}: ChargeGateArgs): boolean =>
  provider === PAYMENT_PROVIDER_OPN && chargeState === 'DEGRADED'
